<template>
  <p class="installation-title" v-if="!installation">
    Installation was not ordered
  </p>
  <div :class="{ hidden: !installation }">
    <InstallationTable />
    <InstallationSubtotal />
    <InstallationDiscount />

    <div class="step__block-field step__block-field--bottom">
      <div class="step__block-field-block">
        <h3>DISCOUNTED INSTALLATION:</h3>
        <PriceValue
          :price="priceWithDiscount"
          class="step__block-field-price"
        />
      </div>
    </div>

    <div class="step-content">
      <InstallationOvercharge />
      <HalfInstallationField />
    </div>

    <InstallationPageTotal />
  </div>
</template>

<script setup lang="ts">
import { computed, watch } from "vue";

import { Pricing } from "@/app/domain";
import { PriceValue } from "@/shared";

import {
  InstallationTable,
  InstallationSubtotal,
  HalfInstallationField,
  InstallationDiscount,
  InstallationPageTotal,
  InstallationOvercharge,
} from "@/modules/installation";

import { PricingService } from "@/app/services/pricing.service";
import { useInstallationStore } from "@/stores/new/installation.store";
import { useNewEstimateStore } from "@/stores/new/estimateStore";

defineExpose({ validatePage });

const newInstallationStore = useInstallationStore();
const estimateStore = useNewEstimateStore();

const pricingService = new PricingService();

const installation = computed(() => estimateStore.estimate.installation);
const priceWithDiscount = computed(
  () => newInstallationStore.priceWithDiscount,
);

function validatePage() {
  return null;
}

const updatePriceWithDiscount = () => {
  const updatedPriceWithDiscount =
    pricingService.calculateInstallationPriceWithDiscount();

  const formattedPriceWithDiscount = new Pricing(
    updatedPriceWithDiscount.price,
    updatedPriceWithDiscount.priceB2C,
    updatedPriceWithDiscount.priceB2B,
  );
  newInstallationStore.priceWithDiscount = formattedPriceWithDiscount;
};

// calculate price with discount
watch(
  () => [newInstallationStore.subtotalPrice, newInstallationStore.totalSquare],
  () => updatePriceWithDiscount(),
  {
    deep: true,
  },
);
</script>

<style scoped>
.hidden {
  position: relative;
  opacity: 0;
  z-index: -10;
}
.step__block-field {
  display: flex;
  justify-content: space-between;
  align-items: center;

  padding: 15px 0;
  border-top: 1px solid #d2d8e3;
  border-bottom: 1px solid #d2d8e3;
}

.step__block-field-block {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.step__block-field.step__block-field--bottom {
  margin-top: 32px;
  padding-bottom: 0;
  border-bottom: none;
}

.step__block-field h3 {
  color: #404d63;
  font-family: Gilroy;
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  text-transform: uppercase;
}

.step__block-field-price {
  color: #404d63;
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  text-transform: uppercase;
}

.step-content {
  display: flex;
  flex-direction: column;
  row-gap: 10px;
  align-items: flex-start;

  margin-top: 32px;
}

.installation-title {
  font-weight: 600;
  font-size: 17px;
  line-height: 100%;
  letter-spacing: 0%;
  text-transform: uppercase;
  color: #7c7f85;
}
</style>
